/**
 * Settings switch: "Share my location during live missions" (prefs.shareLocation, default on)
 * plus a one-line status. Sharing itself is automatic (lib/geolocation AutoShare).
 */
import { autoShare } from '../lib/geolocation';
import { usePrefs } from '../lib/prefs';
import { showLocationHelp, useSharingView } from '../features/live/SharingPill';
import { cx, Toggle } from './ui';

export function ShareLocationSetting() {
  const enabled = usePrefs((s) => s.shareLocation);
  const setPref = usePrefs((s) => s.set);
  const v = useSharingView();
  return (
    <div className="share-setting" data-testid="share-setting">
      <Toggle
        checked={enabled}
        onChange={(on) => {
          setPref('shareLocation', on);
          if (on) autoShare.retry(); // a deliberate "on" may ask the phone again
        }}
        label="Share my location during live missions"
      />
      <div className={cx('share-setting__status', `share-setting__status--${v.tone}`)} data-testid="share-status">
        <span>{v.text}</span>
        {v.issue ? (
          <button type="button" className="share-setting__fix" onClick={showLocationHelp}>
            How to fix
          </button>
        ) : null}
      </div>
    </div>
  );
}
